<template>
  <div class="side_cart_wrapp" :class="{ open: getSideCart }">

    <div class="side_cart">
      <div class="top">
        <p>Korpa</p>
        <button @click="closeSideCart">
          <close-icon></close-icon>
        </button>
      </div>

      <div class="side_cart_items_wrapp">
        <div class="side_cart_items">
          <div class="item" v-for="(item, index) in getCartItems" :key="index">
            <a :href="item.model.path">
              <p class="sr_only">{{ item.name }}</p>
              <img :src="item.model.cartImage" :alt="item.model.short" width="270" height="400">
            </a>

            <div class="description">
              <p><a :href="item.model.path">{{ item.name }}</a></p>
              <p>{{ item.qty }} x {{ formatPrice(item.model.discountedPrice) }} rsd</p>
            </div>

            <remove-icon :index="index">
            </remove-icon>
          </div>

          <div v-if="getCartItems.length < 1">
            <p>Korpa je prazna.</p>
          </div>

        </div>
      </div>

      <div class="bottom">
        <p>Ukupno: <span>{{ formatPrice(getTotalPrice) }} rsd</span></p>
        <a :href="domain + 'korpa'" class="go_to_cart">IDI NA KORPU</a>
      </div>
    </div>

    <div class="side_cart_overlay" @click="closeSideCart"></div>

  </div>
</template>

<script>

import accounting from 'accounting';

export default {
  name: "SideCart",
  data() {
    return {
      domain: domain,
      showModal: false
    }
  },

  computed: {

    /**
     * Retrieve cart items from vuex store
     * That means on every change of vuex state, retrieve changes...
     */
    getCartItems() {

      return this.$store.getters['Cart/getCartItems'];
    },

    /**
     * Retrieve cart items total price from vuex store
     */
    getTotalPrice() {
      return this.$store.getters['Cart/getTotalPrice'];
    },

    /**
     *
     */
    getSideCart() {
      return this.$store.getters['Cart/getSideCart'];
    }

  },

  mounted() {
    const bodyElement = document.querySelector('body');
    if (this.getSideCart) {
      bodyElement.classList.add('no_scroll');
    }
  },

  watch: {
    getSideCart(newVal) {
      const bodyElement = document.querySelector('body');
      if (newVal) {
        bodyElement.classList.add('no_scroll');
      } else {
        bodyElement.classList.remove('no_scroll');
      }
    }
  },

  methods: {
    /**
     * Format price.
     *
     * @param value
     */
    formatPrice(value) {

      return accounting.formatMoney(value, '', 2, '.', ',')
    },

    /**
     * Change vuex state to close side cart.
     */
    closeSideCart() {
      this.$store.dispatch('Cart/changeSideCart', false);
    },

    /**
     * Handle keydown event on the whole document.
     *
     * @param event
     */
    handleKeyDown(event) {
      if (event.key === 'Escape' && this.getSideCart) {
        this.closeSideCart();
      }
    },
  },

  created() {
    document.addEventListener('keydown', this.handleKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}

</script>